import { useContext, useMemo } from 'react';

import { AppContext } from '../context/app';
import { useKioskParams } from './useKioskParams';
import { useKioskRegistration } from './useKioskRegistration';

export const useKioskManager = () => {
  const kioskMode = process.env.REACT_APP_KIOSK_MODE === 'true';
  const kiosk = useKioskParams();
  const { availableSites } = useContext(AppContext);

  const { data: kioskLocation, isLoading: kioskLocationLoading } =
    useKioskRegistration(process.env.REACT_APP_CUSTOMER_ENV!);

  const kioskSite = useMemo(() => {
    const siteId = kioskLocation?.data.site_id;
    return availableSites?.find((site) => site.id === siteId);
  }, [availableSites, kioskLocation?.data.site_id]);

  return {
    kiosk,
    kioskMode,
    kioskRegistration: kioskLocation?.data,
    kioskLocationLoading,
    kioskSite,
  };
};
